// Handle analytics script after static page load (WP Fastest Cache or WP Super Cache) //

function enableGTM(gtmCode) {
  document.querySelectorAll('.sp-cookies.gtm').forEach((script) => {
    script.type = 'text/javascript';
    // eslint-disable-next-line no-eval
    eval(script.innerHTML);
  });

  // Inject noscript iframe manually
  const gtmIframe = document.createElement('iframe');
  gtmIframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmCode}`;
  gtmIframe.height = '0';
  gtmIframe.width = '0';

  document.body.appendChild(gtmIframe);
}

function getGTMCode() {
  const script = document.querySelector('.sp-cookies.gtm');
  if (!script) return null;

  const match = script.innerHTML.match(/'GTM-[^']+'/);
  return match ? match[0].replace(/'/g, '') : null;
}

if (!document.body.classList.contains('preview')) {
  window.addEventListener('DOMContentLoaded', () => {
    const scripts = document.querySelectorAll('.sp-cookies.gtm');
    if (scripts && Cookies.get('performance_cookie')) {
      const gtmCode = getGTMCode();
      loadScripts(scripts);
      enableGTM(gtmCode);
    }
  });

  const loadScripts = (scripts) => {
    scripts.forEach((script) => {
      script.type = 'text/javascript';
      document.head.appendChild(script);
    });
  };

  const { cookieActiveFor = 365 } = document.querySelector('.cookie-banner').dataset;
  const activeDays = Number(cookieActiveFor) || 365;
  attachEvent('.btn--cookie', 'click', (ev) => {
    Cookies.set('performance_cookie', 'cookie-set', { expires: activeDays });
    cookieElement.classList.remove('cookie-not-set');
    ev.preventDefault();
    const scripts = document.querySelectorAll('.sp-cookies.gtm');
    if (scripts && Cookies.get('performance_cookie')) {
      const gtmCode = getGTMCode();
      loadScripts(scripts);
      enableGTM(gtmCode);
    }
  });
}

// *******************************************************************************
// GTM - Consent Default
// *******************************************************************************

const initConsentDefault = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }

  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  });

  const performanceCookie = Cookies.get('performance_cookie');
  const advertisingCookie = Cookies.get('advertising_cookie');

  const updateData = {};
  if (advertisingCookie) {
    updateData.ad_storage = 'granted';
  }

  if (performanceCookie) {
    updateData.analytics_storage = 'granted';
  }

  gtag('consent', 'update', updateData);
};

if (!document.body.classList.contains('preview')) {
  initConsentDefault();
}
